import request from '@/utils/axios.js'

// NFC支持机型查询
export function querySupportNfcPhoneModel (data) {
  return request({
    url: '/qdt-nfc/openAPI/qdt/nfc/querySupportNfcPhoneModel',
    method: 'post',
    data: data
  })
}
// 二维码充值
export function ridingCodeRechargePay (data) {
  return request({
    url: '/qdt-nfc/mobileAPI/qdt/ridingcode/ridingCodeRechargePay',
    method: 'post',
    data: data
  })
}
// 二维码余额
export function queryRidingCodeBalance (data) {
  return request({
    url: '/qdt-nfc/mobileAPI/qdt/ridingcode/queryRidingCodeBalance',
    method: 'post',
    data: data
  })
}
// 计算优惠后金额
export function trialDiscountAmount (data) {
  return request({
    url: '/qdt-nfc/mobileAPI/qdt/trialDiscountAmount',
    method: 'post',
    data: data
  })
}
// 获取优惠券
export function getMyCoupon (data) {
  return request({
    url: '/manageMarket/mobileAPI/coupons/my',
    method: 'post',
    data: data
  })
}

// nfc开卡 发送短信验证码
export function getSmsCode (data) {
  return request({
    url: '/qdt-nfc/openAPI/qdt/thirdservice/sendSmsVerCode',
    method: 'post',
    data: data
  })
}

// nfc开卡 特种卡申请验证
export function specialNFCVerification (data) {
  return request({
    url: '/qdt-nfc/openAPI/qdt/thirdservice/specialcard/specialcardApplicationVerification',
    method: 'post',
    data: data
  })
}

// nfc开卡 特种卡申请记录查询
export function specialNFCVerList (data) {
  return request({
    url: '/qdt-nfc/openAPI/qdt/thirdservice/specialcard/querySpecialcardApplicationRecords',
    method: 'post',
    data: data
  })
}

// nfc开卡 特种卡申请
export function specialNFCOpen (data) {
  return request({
    url: '/qdt-nfc/openAPI/qdt/thirdservice/specialcard/specialcardApplication',
    method: 'post',
    data: data
  })
}

// nfc开卡 特种卡卡面信息查询
export function specialNFCInfo (data) {
  return request({
    url: '/qdt-nfc/openAPI/qdt/thirdservice/specialcard/showSpecialCard',
    method: 'post',
    data: data
  })
}
